/**
 * @fileoverview gRPC-Web generated client stub for notification
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: notification/notification.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.notification = require('./notification_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.notification.NotificationClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.notification.NotificationPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.GetNotificationsRequest,
 *   !proto.notification.GetNotificationsResponse>}
 */
const methodDescriptor_Notification_GetNotifications = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetNotifications',
  grpc.web.MethodType.UNARY,
  proto.notification.GetNotificationsRequest,
  proto.notification.GetNotificationsResponse,
  /**
   * @param {!proto.notification.GetNotificationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.GetNotificationsResponse.deserializeBinary
);


/**
 * @param {!proto.notification.GetNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.GetNotificationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.GetNotificationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getNotifications =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetNotifications',
      request,
      metadata || {},
      methodDescriptor_Notification_GetNotifications,
      callback);
};


/**
 * @param {!proto.notification.GetNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.GetNotificationsResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getNotifications =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetNotifications',
      request,
      metadata || {},
      methodDescriptor_Notification_GetNotifications);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.LatestNotificationRequest,
 *   !proto.notification.LatestNotificationResponse>}
 */
const methodDescriptor_Notification_GetLatestNotification = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetLatestNotification',
  grpc.web.MethodType.UNARY,
  proto.notification.LatestNotificationRequest,
  proto.notification.LatestNotificationResponse,
  /**
   * @param {!proto.notification.LatestNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.LatestNotificationResponse.deserializeBinary
);


/**
 * @param {!proto.notification.LatestNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.LatestNotificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.LatestNotificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getLatestNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetLatestNotification',
      request,
      metadata || {},
      methodDescriptor_Notification_GetLatestNotification,
      callback);
};


/**
 * @param {!proto.notification.LatestNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.LatestNotificationResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getLatestNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetLatestNotification',
      request,
      metadata || {},
      methodDescriptor_Notification_GetLatestNotification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.DismissNotificationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_DismissNotification = new grpc.web.MethodDescriptor(
  '/notification.Notification/DismissNotification',
  grpc.web.MethodType.UNARY,
  proto.notification.DismissNotificationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.DismissNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.DismissNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.dismissNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/DismissNotification',
      request,
      metadata || {},
      methodDescriptor_Notification_DismissNotification,
      callback);
};


/**
 * @param {!proto.notification.DismissNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.dismissNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/DismissNotification',
      request,
      metadata || {},
      methodDescriptor_Notification_DismissNotification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.AddSubscriptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_AddSubscription = new grpc.web.MethodDescriptor(
  '/notification.Notification/AddSubscription',
  grpc.web.MethodType.UNARY,
  proto.notification.AddSubscriptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.AddSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.AddSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.addSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/AddSubscription',
      request,
      metadata || {},
      methodDescriptor_Notification_AddSubscription,
      callback);
};


/**
 * @param {!proto.notification.AddSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.addSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/AddSubscription',
      request,
      metadata || {},
      methodDescriptor_Notification_AddSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.RemoveSubscriptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_RemoveSubscription = new grpc.web.MethodDescriptor(
  '/notification.Notification/RemoveSubscription',
  grpc.web.MethodType.UNARY,
  proto.notification.RemoveSubscriptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.RemoveSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.RemoveSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.removeSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/RemoveSubscription',
      request,
      metadata || {},
      methodDescriptor_Notification_RemoveSubscription,
      callback);
};


/**
 * @param {!proto.notification.RemoveSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.removeSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/RemoveSubscription',
      request,
      metadata || {},
      methodDescriptor_Notification_RemoveSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.GetSubscriptionRequest,
 *   !proto.notification.Subscription>}
 */
const methodDescriptor_Notification_GetSubscriptionBySubjectId = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetSubscriptionBySubjectId',
  grpc.web.MethodType.UNARY,
  proto.notification.GetSubscriptionRequest,
  proto.notification.Subscription,
  /**
   * @param {!proto.notification.GetSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.Subscription.deserializeBinary
);


/**
 * @param {!proto.notification.GetSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.Subscription)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.Subscription>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getSubscriptionBySubjectId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetSubscriptionBySubjectId',
      request,
      metadata || {},
      methodDescriptor_Notification_GetSubscriptionBySubjectId,
      callback);
};


/**
 * @param {!proto.notification.GetSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.Subscription>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getSubscriptionBySubjectId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetSubscriptionBySubjectId',
      request,
      metadata || {},
      methodDescriptor_Notification_GetSubscriptionBySubjectId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.SetNotificationChannelRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_SetNotificationChannel = new grpc.web.MethodDescriptor(
  '/notification.Notification/SetNotificationChannel',
  grpc.web.MethodType.UNARY,
  proto.notification.SetNotificationChannelRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.SetNotificationChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.SetNotificationChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.setNotificationChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/SetNotificationChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_SetNotificationChannel,
      callback);
};


/**
 * @param {!proto.notification.SetNotificationChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.setNotificationChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/SetNotificationChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_SetNotificationChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.DeleteNotificationChannelRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_DeleteNotificationChannel = new grpc.web.MethodDescriptor(
  '/notification.Notification/DeleteNotificationChannel',
  grpc.web.MethodType.UNARY,
  proto.notification.DeleteNotificationChannelRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.DeleteNotificationChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.DeleteNotificationChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.deleteNotificationChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/DeleteNotificationChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_DeleteNotificationChannel,
      callback);
};


/**
 * @param {!proto.notification.DeleteNotificationChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.deleteNotificationChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/DeleteNotificationChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_DeleteNotificationChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.GetNotificationChannelRequest,
 *   !proto.notification.NotificationChannelResponse>}
 */
const methodDescriptor_Notification_GetNotificationChannel = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetNotificationChannel',
  grpc.web.MethodType.UNARY,
  proto.notification.GetNotificationChannelRequest,
  proto.notification.NotificationChannelResponse,
  /**
   * @param {!proto.notification.GetNotificationChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.NotificationChannelResponse.deserializeBinary
);


/**
 * @param {!proto.notification.GetNotificationChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.NotificationChannelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.NotificationChannelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getNotificationChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetNotificationChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_GetNotificationChannel,
      callback);
};


/**
 * @param {!proto.notification.GetNotificationChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.NotificationChannelResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getNotificationChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetNotificationChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_GetNotificationChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.SetOrgPolicyRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_SetOrgNotificationPolicy = new grpc.web.MethodDescriptor(
  '/notification.Notification/SetOrgNotificationPolicy',
  grpc.web.MethodType.UNARY,
  proto.notification.SetOrgPolicyRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.SetOrgPolicyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.SetOrgPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.setOrgNotificationPolicy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/SetOrgNotificationPolicy',
      request,
      metadata || {},
      methodDescriptor_Notification_SetOrgNotificationPolicy,
      callback);
};


/**
 * @param {!proto.notification.SetOrgPolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.setOrgNotificationPolicy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/SetOrgNotificationPolicy',
      request,
      metadata || {},
      methodDescriptor_Notification_SetOrgNotificationPolicy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.notification.OrgPolicyResponse>}
 */
const methodDescriptor_Notification_GetOrgNotificationPolicy = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetOrgNotificationPolicy',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.notification.OrgPolicyResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.OrgPolicyResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.OrgPolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.OrgPolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getOrgNotificationPolicy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetOrgNotificationPolicy',
      request,
      metadata || {},
      methodDescriptor_Notification_GetOrgNotificationPolicy,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.OrgPolicyResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getOrgNotificationPolicy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetOrgNotificationPolicy',
      request,
      metadata || {},
      methodDescriptor_Notification_GetOrgNotificationPolicy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.SetPreferenceRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_SetUserNotificationPreference = new grpc.web.MethodDescriptor(
  '/notification.Notification/SetUserNotificationPreference',
  grpc.web.MethodType.UNARY,
  proto.notification.SetPreferenceRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.SetPreferenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.SetPreferenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.setUserNotificationPreference =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/SetUserNotificationPreference',
      request,
      metadata || {},
      methodDescriptor_Notification_SetUserNotificationPreference,
      callback);
};


/**
 * @param {!proto.notification.SetPreferenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.setUserNotificationPreference =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/SetUserNotificationPreference',
      request,
      metadata || {},
      methodDescriptor_Notification_SetUserNotificationPreference);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.notification.PreferenceResponse>}
 */
const methodDescriptor_Notification_GetUserNotificationPreference = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetUserNotificationPreference',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.notification.PreferenceResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.PreferenceResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.PreferenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.PreferenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getUserNotificationPreference =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetUserNotificationPreference',
      request,
      metadata || {},
      methodDescriptor_Notification_GetUserNotificationPreference,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.PreferenceResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getUserNotificationPreference =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetUserNotificationPreference',
      request,
      metadata || {},
      methodDescriptor_Notification_GetUserNotificationPreference);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.MarkNotificationReadRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_MarkNotificationRead = new grpc.web.MethodDescriptor(
  '/notification.Notification/MarkNotificationRead',
  grpc.web.MethodType.UNARY,
  proto.notification.MarkNotificationReadRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.MarkNotificationReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.MarkNotificationReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.markNotificationRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/MarkNotificationRead',
      request,
      metadata || {},
      methodDescriptor_Notification_MarkNotificationRead,
      callback);
};


/**
 * @param {!proto.notification.MarkNotificationReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.markNotificationRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/MarkNotificationRead',
      request,
      metadata || {},
      methodDescriptor_Notification_MarkNotificationRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_MarkAllNotificationsRead = new grpc.web.MethodDescriptor(
  '/notification.Notification/MarkAllNotificationsRead',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.markAllNotificationsRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/MarkAllNotificationsRead',
      request,
      metadata || {},
      methodDescriptor_Notification_MarkAllNotificationsRead,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.markAllNotificationsRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/MarkAllNotificationsRead',
      request,
      metadata || {},
      methodDescriptor_Notification_MarkAllNotificationsRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_MarkBellViewed = new grpc.web.MethodDescriptor(
  '/notification.Notification/MarkBellViewed',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.markBellViewed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/MarkBellViewed',
      request,
      metadata || {},
      methodDescriptor_Notification_MarkBellViewed,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.markBellViewed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/MarkBellViewed',
      request,
      metadata || {},
      methodDescriptor_Notification_MarkBellViewed);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.notification.UnreadCountResponse>}
 */
const methodDescriptor_Notification_GetUnreadCount = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetUnreadCount',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.notification.UnreadCountResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.UnreadCountResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.UnreadCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.UnreadCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getUnreadCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetUnreadCount',
      request,
      metadata || {},
      methodDescriptor_Notification_GetUnreadCount,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.UnreadCountResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getUnreadCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetUnreadCount',
      request,
      metadata || {},
      methodDescriptor_Notification_GetUnreadCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.MarkNotificationReadRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_DeleteNotification = new grpc.web.MethodDescriptor(
  '/notification.Notification/DeleteNotification',
  grpc.web.MethodType.UNARY,
  proto.notification.MarkNotificationReadRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.MarkNotificationReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.MarkNotificationReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.deleteNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/DeleteNotification',
      request,
      metadata || {},
      methodDescriptor_Notification_DeleteNotification,
      callback);
};


/**
 * @param {!proto.notification.MarkNotificationReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.deleteNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/DeleteNotification',
      request,
      metadata || {},
      methodDescriptor_Notification_DeleteNotification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_DeleteAllNotifications = new grpc.web.MethodDescriptor(
  '/notification.Notification/DeleteAllNotifications',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.deleteAllNotifications =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/DeleteAllNotifications',
      request,
      metadata || {},
      methodDescriptor_Notification_DeleteAllNotifications,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.deleteAllNotifications =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/DeleteAllNotifications',
      request,
      metadata || {},
      methodDescriptor_Notification_DeleteAllNotifications);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.OrgIntegrationRequest,
 *   !proto.notification.OrgIntegrationResponse>}
 */
const methodDescriptor_Notification_GetOrgIntegration = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetOrgIntegration',
  grpc.web.MethodType.UNARY,
  proto.notification.OrgIntegrationRequest,
  proto.notification.OrgIntegrationResponse,
  /**
   * @param {!proto.notification.OrgIntegrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.OrgIntegrationResponse.deserializeBinary
);


/**
 * @param {!proto.notification.OrgIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.OrgIntegrationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.OrgIntegrationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getOrgIntegration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetOrgIntegration',
      request,
      metadata || {},
      methodDescriptor_Notification_GetOrgIntegration,
      callback);
};


/**
 * @param {!proto.notification.OrgIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.OrgIntegrationResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getOrgIntegration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetOrgIntegration',
      request,
      metadata || {},
      methodDescriptor_Notification_GetOrgIntegration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.AddOrgChannelRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_AddOrgChannel = new grpc.web.MethodDescriptor(
  '/notification.Notification/AddOrgChannel',
  grpc.web.MethodType.UNARY,
  proto.notification.AddOrgChannelRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.AddOrgChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.AddOrgChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.addOrgChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/AddOrgChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_AddOrgChannel,
      callback);
};


/**
 * @param {!proto.notification.AddOrgChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.addOrgChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/AddOrgChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_AddOrgChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.RemoveOrgChannelRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_RemoveOrgChannel = new grpc.web.MethodDescriptor(
  '/notification.Notification/RemoveOrgChannel',
  grpc.web.MethodType.UNARY,
  proto.notification.RemoveOrgChannelRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.RemoveOrgChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.RemoveOrgChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.removeOrgChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/RemoveOrgChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_RemoveOrgChannel,
      callback);
};


/**
 * @param {!proto.notification.RemoveOrgChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.removeOrgChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/RemoveOrgChannel',
      request,
      metadata || {},
      methodDescriptor_Notification_RemoveOrgChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.OrgIntegrationRequest,
 *   !proto.notification.GetOrgConfigResponse>}
 */
const methodDescriptor_Notification_GetOrgConfig = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetOrgConfig',
  grpc.web.MethodType.UNARY,
  proto.notification.OrgIntegrationRequest,
  proto.notification.GetOrgConfigResponse,
  /**
   * @param {!proto.notification.OrgIntegrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.GetOrgConfigResponse.deserializeBinary
);


/**
 * @param {!proto.notification.OrgIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.GetOrgConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.GetOrgConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getOrgConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetOrgConfig',
      request,
      metadata || {},
      methodDescriptor_Notification_GetOrgConfig,
      callback);
};


/**
 * @param {!proto.notification.OrgIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.GetOrgConfigResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getOrgConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetOrgConfig',
      request,
      metadata || {},
      methodDescriptor_Notification_GetOrgConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.SetOrgRoutesRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_SetOrgRoutes = new grpc.web.MethodDescriptor(
  '/notification.Notification/SetOrgRoutes',
  grpc.web.MethodType.UNARY,
  proto.notification.SetOrgRoutesRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.SetOrgRoutesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.SetOrgRoutesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.setOrgRoutes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/SetOrgRoutes',
      request,
      metadata || {},
      methodDescriptor_Notification_SetOrgRoutes,
      callback);
};


/**
 * @param {!proto.notification.SetOrgRoutesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.setOrgRoutes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/SetOrgRoutes',
      request,
      metadata || {},
      methodDescriptor_Notification_SetOrgRoutes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.ListOrgChannelsRequest,
 *   !proto.notification.ListOrgChannelsResponse>}
 */
const methodDescriptor_Notification_ListOrgChannels = new grpc.web.MethodDescriptor(
  '/notification.Notification/ListOrgChannels',
  grpc.web.MethodType.UNARY,
  proto.notification.ListOrgChannelsRequest,
  proto.notification.ListOrgChannelsResponse,
  /**
   * @param {!proto.notification.ListOrgChannelsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.ListOrgChannelsResponse.deserializeBinary
);


/**
 * @param {!proto.notification.ListOrgChannelsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.ListOrgChannelsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.ListOrgChannelsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.listOrgChannels =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/ListOrgChannels',
      request,
      metadata || {},
      methodDescriptor_Notification_ListOrgChannels,
      callback);
};


/**
 * @param {!proto.notification.ListOrgChannelsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.ListOrgChannelsResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.listOrgChannels =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/ListOrgChannels',
      request,
      metadata || {},
      methodDescriptor_Notification_ListOrgChannels);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification.OrgIntegrationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Notification_DeactivateOrgIntegration = new grpc.web.MethodDescriptor(
  '/notification.Notification/DeactivateOrgIntegration',
  grpc.web.MethodType.UNARY,
  proto.notification.OrgIntegrationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.notification.OrgIntegrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.notification.OrgIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.deactivateOrgIntegration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/DeactivateOrgIntegration',
      request,
      metadata || {},
      methodDescriptor_Notification_DeactivateOrgIntegration,
      callback);
};


/**
 * @param {!proto.notification.OrgIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.deactivateOrgIntegration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/DeactivateOrgIntegration',
      request,
      metadata || {},
      methodDescriptor_Notification_DeactivateOrgIntegration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.notification.OAuthURLResponse>}
 */
const methodDescriptor_Notification_GetSlackOrgOAuthURL = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetSlackOrgOAuthURL',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.notification.OAuthURLResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.OAuthURLResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.OAuthURLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.OAuthURLResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getSlackOrgOAuthURL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetSlackOrgOAuthURL',
      request,
      metadata || {},
      methodDescriptor_Notification_GetSlackOrgOAuthURL,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.OAuthURLResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getSlackOrgOAuthURL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetSlackOrgOAuthURL',
      request,
      metadata || {},
      methodDescriptor_Notification_GetSlackOrgOAuthURL);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.notification.OAuthURLResponse>}
 */
const methodDescriptor_Notification_GetSlackPersonalOAuthURL = new grpc.web.MethodDescriptor(
  '/notification.Notification/GetSlackPersonalOAuthURL',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.notification.OAuthURLResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.notification.OAuthURLResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification.OAuthURLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification.OAuthURLResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.notification.NotificationClient.prototype.getSlackPersonalOAuthURL =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/notification.Notification/GetSlackPersonalOAuthURL',
      request,
      metadata || {},
      methodDescriptor_Notification_GetSlackPersonalOAuthURL,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification.OAuthURLResponse>}
 *     Promise that resolves to the response
 */
proto.notification.NotificationPromiseClient.prototype.getSlackPersonalOAuthURL =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/notification.Notification/GetSlackPersonalOAuthURL',
      request,
      metadata || {},
      methodDescriptor_Notification_GetSlackPersonalOAuthURL);
};


module.exports = proto.notification;

